import React, { FC, useContext } from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import makeStyles from '@material-ui/core/styles/makeStyles'
import DocumentVerificationIcon from 'components/DocumentVerificationIcon'
import { DocumentVerificationContext } from 'contexts/documentVerificationContext'
import { findFieldVerification, getFieldVerificationMessage, getFieldVerificationSource, getVerdictSeverity } from 'utils/documentVerificationHelpers'
import { VerificationFieldKey, VerificationTargetEntity } from 'typescript/enums/documentVerification'

const useFieldVerificationBadgeStyles = makeStyles(theme => ({
  badge: {
    display: 'inline-flex',
    verticalAlign: 'middle',
    marginLeft: theme.spacing(2),
  },
  source: {
    marginTop: theme.spacing(1),
    fontSize: '0.875rem',
    opacity: 0.8,
  },
}))

interface IFieldVerificationBadgeProps {
  targetEntity: VerificationTargetEntity
  targetEntityId: number | string | undefined
  fieldKey: VerificationFieldKey
}

const FieldVerificationBadge: FC<IFieldVerificationBadgeProps> = ({ targetEntity, targetEntityId, fieldKey }) => {
  const classes = useFieldVerificationBadgeStyles()
  const verification = useContext(DocumentVerificationContext)
  const field = findFieldVerification(verification, targetEntity, targetEntityId, fieldKey)

  if (!verification || !field) return null

  const source = getFieldVerificationSource(field, verification.documents)

  return (
    <Tooltip
      title={
        <>
          <div>{getFieldVerificationMessage(field, verification.documents)}</div>
          {source && <div className={classes.source}>{source}</div>}
        </>
      }
    >
      <span className={classes.badge}>
        <DocumentVerificationIcon severity={getVerdictSeverity(field.verdict)} />
      </span>
    </Tooltip>
  )
}

export default FieldVerificationBadge
